export const YesOrNo = ["Yes", "No"];
